// extracted by mini-css-extract-plugin
module.exports = {"nur-card":"Card_nur-card__3PtYU","date-box":"Card_date-box__2XzSM","name":"Card_name__6UIe8","img-box":"Card_img-box__2Oc__"};